import style from "./TableHead.module.scss";

export function TableHead() {
    return (
        <div className={style.head}>
            <div>Назва витрати</div>
            <div>Сума</div>
        </div>
    )
}